import React, { ReactElement, useEffect, useState } from 'react';
import ChampFormulaire from '../../Common/ChampFormulaire';
import { Activite, Entente, HistoriqueLogs, Lieu } from '../../../../../common/src/entities';
import { useFormikContext } from 'formik';
import { useGetQuery } from '../../../Utils/api';
import FormulaireModificationEntite from '../Utils/FormulaireModificationEntite';
import { useParams } from 'react-router-dom';
import LogsLoader, { dateFormatter } from '../Utils/Log';
import ChampMultipleClientContact from '../Contacts/ChampMultipleClientContact';
import {
    cssTexte,
    GROUPES_AGES,
    LABEL_COL,
    SUGGESTIONS_CONDITION,
    SUGGESTIONS_CONTEXTE,
    SUGGESTIONS_POSTE,
} from '../constantes';
import { ModalClientContact } from '../Clients/ModalClientContact';
import ChampMultipleRoles from '../Clients/ChampMultipleRoles';
import RolesContainer from '../RolesContainer';
import { Button, Col, Form, Row, Modal } from 'react-bootstrap';
import { TitreCarte } from '../../Common/TitreCarte';
import ChampMultipleClient from '../Clients/ChampMultipleClient';
import { isArray } from 'lodash';
import CheckboxFormulaire from '../../Common/CheckboxFormulaire';
import { CopierPressePapier } from '../Utils/CopierPressePapier';
import PopoverSimple from '../../Common/PopoverSimple';
import { BiNote, BiChevronDown, BiChevronUp } from 'react-icons/bi';
import { EtatEntite } from '../../Common/EtatEntite';
import ChampUniqueLieu from '../Lieux/ChampUniqueLieu';
import ClientLieu from '../../../../../common/src/entities/client-lieu.entity';
import { MyPaper } from '../Utils/MyPaper';
import ChampMultipleActivite from '../Activites/ChampMultipleActivite';
import ActiviteEntente from '../../../../../common/src/entities/activite-entente.entity';
import { MultiSelect } from '../Utils/MultiSelect';
import LieuActivite from '../../../../../common/src/entities/lieu-activite.entity';
import TableActiviteEntenteProduit from './ActiviteEntenteProduits/TableActiviteEntenteProduit';
import TableHoraireEntente from './Horaire/TableHoraireEntente';
import NotesEntente from './Notes/NotesEntente';
import axios from 'axios';
import ChampMultipleModelesHoraire from '../ModelesHoraire/ChampMultipleModelesHoraire';
import { Horaire } from '../../../../../common/src/entities/horaire.entity';
import HistoriqueCourrielsEntente from './Courriels/HistoriqueCourrielsEntente';
import { Tooltip } from '../../Common/Tooltip';

export function ChampsEntente(): ReactElement {
    const { values, setFieldValue } = useFormikContext<Entente>();
    const client_id = values.fk_id_client;
    const [afficherModalClientContact, setAfficherModalClientContact] = useState<boolean>(false);
    const [indexModalClientContact, setIndexModalClientContact] = useState<number>(0);

    const [grandeurGym, setGrandeurGym] = useState<string>('');
    const [hasGrandeurGym, setHasGrandeurGym] = useState<boolean>(false);
    const [lieux, setLieux] = useState<ClientLieu[] | LieuActivite[]>([]);
    const [afficherChampsClient, setAfficherChampsClient] = useState<boolean>(false);
    const [modeleHoraireSelectionne, setModeleHoraireSelectionne] = useState<boolean>(false);
    const { id } = useParams() as { id: string };

    const [showModal, setShowModal] = useState(false);
    const [pendingValue, setPendingValue] = useState<boolean | null>(null);

    useEffect(() => {
        const init = async () => {
            setFieldValue(
                'activiteEntentes',
                values.activiteEntentes?.length > 0
                    ? [...values.activiteEntentes].sort((a, b) => a.priorite - b.priorite)
                    : [null],
            );
            setFieldValue(
                'horaire',
                values.horaire || { tableauPlageHoraire: { headers: [], cellules: [] }, plagesHoraires: [] },
            );
            setModeleHoraireSelectionne(values?.horaire && values?.horaire.plagesHoraires.length > 0);
            let response = await axios.get('../../api/lieux');
            response.data = response.data.map((lieu: Lieu) => {
                return { lieu };
            });
            setLieux(response.data);
            setAfficherChampsClient(true);
        };

        init();
    }, []);

    useEffect(() => {
        if (values['copie_locale_client'] !== undefined && !values['copie_locale_client']) {
            setFieldValue('contacts', values.client?.contacts || []);
            setFieldValue('roles', values.client?.roles || ';;;;');
        } else if (values['copie_locale_client'] === undefined) {
            setFieldValue('copie_locale_client', values.contacts?.length > 0);
            if (values.contacts?.length === 0) {
                setFieldValue('contacts', values.client?.contacts || []);
                setFieldValue('roles', values.client?.roles || ';;;;');
            }
        }
    }, [values['copie_locale_client']]);

    const handleCheckboxChange = (checked) => {
        if (!checked) {
            setPendingValue(false);
            setShowModal(true);
        } else {
            setFieldValue('copie_locale_client', true);
        }
    };

    const confirmChange = () => {
        setShowModal(false);
        if (pendingValue === false) {
            setFieldValue('copie_locale_client', false);
            setFieldValue('contacts', values.client?.contacts || []);
            setFieldValue('roles', values.client?.roles || ';;;;');
        }
    };

    useEffect(() => {
        let lieux: LieuActivite[] = [];
        if (values.activiteEntentes) {
            for (const activiteEntente of values.activiteEntentes) {
                if (
                    activiteEntente &&
                    activiteEntente.activite?.typeActivite &&
                    ((activiteEntente.activite.typeActivite as unknown) as string) === 'Sortie'
                ) {
                    lieux = lieux.concat(activiteEntente.activite.lieux);
                }
            }
            if (lieux.length > 0) setFieldValue('lieu', lieux[0].lieu);
        }
    }, [values.activiteEntentes]);

    useEffect(() => {
        if (isArray(values.client)) {
            setFieldValue('client', values.client[0]);
        }

        if (values.client !== undefined && values.client?.id !== client_id) {
            let client = values.client;

            setFieldValue('afficher_grandeur_gym', true);
            setFieldValue('adresse_facturation', client?.adresse_facturation);
            setFieldValue('contacts', values.client?.contacts);
            setFieldValue('roles', client?.roles || ';;;;');
            setHasGrandeurGym(client?.grandeur_gym?.trim().length > 0);
            setGrandeurGym(client?.grandeur_gym);
            setAfficherChampsClient(true);
        } else if (values.client === undefined) {
            setFieldValue('copie_locale_client', false);
            setFieldValue('contacts', []);
            setFieldValue('roles', ';;;;');
            setFieldValue('groupe_age', '');
            setHasGrandeurGym(false);
            setGrandeurGym('');
        }
    }, [values.client]);

    useEffect(() => {
        if (!values.conditionsFormulaire) return;

        setFieldValue(
            'conditions',
            values?.conditionsFormulaire?.map((name) => ({
                fk_id_entente: values.id,

                name,
            })),
        );
    }, [values.conditionsFormulaire]);

    function ouvrirModalClientContact(index: number): void {
        setIndexModalClientContact(index);
        setAfficherModalClientContact(true);
    }

    function ajouterActivite() {
        setFieldValue('activiteEntentes', [...values.activiteEntentes, null]);
    }

    function supprimerActivite(index: number) {
        const newActivites = values.activiteEntentes.filter((_, i) => i !== index);
        setFieldValue('activiteEntentes', newActivites);
    }

    function initActivite(index: number, activite: Activite) {
        const newActiviteEntentes: Partial<ActiviteEntente>[] = [...values.activiteEntentes];
        newActiviteEntentes[index] = {} as any;
        newActiviteEntentes[index].activite = activite;
        newActiviteEntentes[index].activiteEntenteProduit = [];
        setFieldValue('activiteEntentes', newActiviteEntentes);
    }

    function initHoraire(horaire: Horaire) {
        const newHoraire = {
            ...horaire,
            id: 0,
            tableauPlageHoraire: {
                headers: horaire.tableauPlageHoraire.headers
                    .sort((a, b) => a.ordre - b.ordre)
                    .map((header) => ({
                        ...header,
                        id: 0,
                        cellules: header.cellules
                            .sort((a, b) => a.ordre - b.ordre)
                            .map((cellule) => ({
                                ...cellule,
                                id: 0,
                            })),
                    })),
            },
            plagesHoraires: horaire.plagesHoraires
                .sort((a, b) => a.ordre - b.ordre)
                .map((plageHoraire) => ({
                    ...plageHoraire,
                    id: 0,
                    pour_quoi: Array.from(clientActiviteFournisseurMapHoraire.keys()).join(';'),
                })),
        };

        setFieldValue(`horaire`, newHoraire);
        setModeleHoraireSelectionne(true);
    }

    function EtatEntente(): JSX.Element {
        return (
            <EtatEntite marginTop textColor={values.statut === 'Annulé' ? 'red' : ''}>
                Statut de l'entente : {values?.statut || 'En création'}
            </EtatEntite>
        );
    }

    const clientActiviteFournisseurMapHoraire = React.useMemo(() => {
        const map = new Map<string, string>();
        if (values.client) map.set(`client${values.client.id}`, 'Client ' + values.client.name);
        values?.activiteEntentes?.forEach((activiteEntente) => {
            const activite = activiteEntente?.activite;
            if (!activite?.typeActivite) return;
            if (activite.typeActivite.name === 'Autobus') {
                map.set(`autobus${activite.id}`, 'Autobus ' + activite.name);
            }
            map.set(`fournisseur${activite.fournisseur.id}`, 'Fournisseur ' + activite.fournisseur.name);
        });

        return map;
    }, [values.client, values.activiteEntentes]);

    const moveActivite = (fromIndex: number, toIndex: number) => {
        if (toIndex < 0 || toIndex >= values.activiteEntentes.length) return;

        const updatedActivites = [...values.activiteEntentes];
        const temp = updatedActivites[fromIndex];
        updatedActivites[fromIndex] = updatedActivites[toIndex];
        updatedActivites[toIndex] = temp;

        setFieldValue('activiteEntentes', updatedActivites);
    };

    return (
        <div className="pb-5">
            {EtatEntente()}
            <TitreCarte>
                <Row>
                    <Col xs={LABEL_COL}>Client</Col>
                    <Col style={cssTexte}>
                        <CheckboxFormulaire
                            id="cbxCopieLocale"
                            titre="Créer une copie locale du client"
                            notifyChange={handleCheckboxChange}
                            isChecked={values['copie_locale_client']}
                        />
                        <Modal show={showModal} onHide={() => setShowModal(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>Confirmation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>Êtes-vous sûr de vouloir supprimer la copie locale du client ?</Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowModal(false)}>
                                    Annuler
                                </Button>
                                <Button variant="danger" onClick={confirmChange}>
                                    Confirmer
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </Col>
                </Row>
            </TitreCarte>
            <MyPaper>
                <ChampMultipleClient id="client" maxSize={1} title="Client" labelCol={LABEL_COL} avecUnBouton />
                {afficherChampsClient && (
                    <>
                        <ChampUniqueLieu
                            id="adresse_facturation"
                            placeholder="Aucune adresse de facturation"
                            lieux={values.client?.lieux}
                            label={'Adresse de facturation'}
                            titreBouton="Choisir l'adresse de facturation"
                            selectedLieu={
                                values.copie_locale_client
                                    ? values.adresse_facturation
                                    : values.client?.adresse_facturation
                            }
                            oneLiner
                            hideX
                            disabled={!values['copie_locale_client']}
                            disableOnce
                        />
                        <ChampMultipleClientContact
                            id="contacts"
                            labelCol={LABEL_COL}
                            avecUnBouton
                            details={(index: number) => `contacts[${index}].poste`}
                            suggestions={SUGGESTIONS_POSTE}
                            placeholder="Poste"
                            clickCrayon={ouvrirModalClientContact}
                            disabled={!values['copie_locale_client']}
                        />
                        <RolesContainer key={values.roles}>
                            <ChampMultipleRoles
                                numeroRole={1}
                                nomRole={"Planification d'activité"}
                                disabled={!values['copie_locale_client']}
                            />
                            <ChampMultipleRoles
                                numeroRole={2}
                                nomRole={"Approbation d'activité"}
                                disabled={!values['copie_locale_client']}
                            />
                            <ChampMultipleRoles
                                numeroRole={3}
                                nomRole={'Organisation de parascolaires'}
                                disabled={!values['copie_locale_client']}
                            />
                            <ChampMultipleRoles
                                numeroRole={4}
                                nomRole={'Facturation'}
                                disabled={!values['copie_locale_client']}
                            />
                        </RolesContainer>
                        {hasGrandeurGym && (
                            <Row>
                                <Col xs={LABEL_COL}>Grandeur du gymnase</Col>
                                <Col>
                                    <CheckboxFormulaire
                                        id={`afficher_grandeur_gym`}
                                        titre={
                                            <span style={{ fontSize: '14px' }}>
                                                Afficher la grandeur du gymnase dans les documents{' '}
                                                <CopierPressePapier texte={grandeurGym}>
                                                    <PopoverSimple texte={grandeurGym} titre="Grandeur du gymnase">
                                                        <BiNote />
                                                    </PopoverSimple>
                                                </CopierPressePapier>
                                            </span>
                                        }
                                    />
                                </Col>
                            </Row>
                        )}
                    </>
                )}
            </MyPaper>
            {values.id && (
                <>
                    <TitreCarte>Détails de l'entente</TitreCarte>
                    <MyPaper>
                        <ChampFormulaire labelCol={LABEL_COL} id="name" titre="Nom" estPetit />
                        <ChampFormulaire
                            labelCol={LABEL_COL}
                            id="date_activite"
                            type="date"
                            trimDateText
                            titre="Date de l'activité"
                            estPetit
                        />
                        <MultiSelect
                            id={'conditionsFormulaire'}
                            titre={'Conditions'}
                            values={values?.conditions?.map((c) => c.name)}
                            suggestions={SUGGESTIONS_CONDITION}
                            placeholder={'Aucune condition pour le moment'}
                        />

                        <ChampFormulaire
                            id={`contexte`}
                            titre={'Contexte'}
                            isCreatable
                            suggestions={SUGGESTIONS_CONTEXTE}
                            estPetit
                            labelCol={LABEL_COL}
                        />
                        <ChampFormulaire
                            labelCol={LABEL_COL}
                            suggestions={GROUPES_AGES}
                            isCreatable
                            id="groupe_age"
                            titre="Groupe d'âge"
                            estPetit
                        />
                    </MyPaper>
                    <TitreCarte>Activités</TitreCarte>
                    <MyPaper>
                        {values.activiteEntentes &&
                            values.activiteEntentes.map((activiteEntente, index) => {
                                const isFirst = index === 0;
                                const isLast = index === values.activiteEntentes.length - 1;
                                return (
                                    <>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            disabled={isLast}
                                            onClick={() => !isLast && moveActivite(index, index + 1)}
                                        >
                                            <BiChevronDown
                                                style={{
                                                    cursor: isLast ? 'not-allowed' : 'pointer',
                                                    color: isLast ? 'grey' : 'blue',
                                                }}
                                            />
                                        </Button>

                                        <Button
                                            variant="light"
                                            size="sm"
                                            disabled={isFirst}
                                            onClick={() => !isFirst && moveActivite(index, index - 1)}
                                        >
                                            <BiChevronUp
                                                style={{
                                                    cursor: isFirst ? 'not-allowed' : 'pointer',
                                                    color: isFirst ? 'grey' : 'blue',
                                                }}
                                            />
                                        </Button>

                                        <ChampMultipleActivite
                                            id={`activiteEntentes[${index}].activite`}
                                            maxSize={1}
                                            title="Activité"
                                            labelCol={LABEL_COL}
                                            avecUnBouton
                                            onChange={(activite: Activite) => initActivite(index, activite)}
                                        />

                                        {activiteEntente && activiteEntente.activite && (
                                            <>
                                                <ChampFormulaire
                                                    labelCol={LABEL_COL}
                                                    suggestions={activiteEntente.activite.thematiques?.map((t) => ({
                                                        value: t.id,
                                                        label: t.name,
                                                    }))}
                                                    id={`activiteEntentes[${index}].thematique.name`}
                                                    titre="Thématique"
                                                    estPetit
                                                    disabled={!activiteEntente || !activiteEntente.activite}
                                                    notifyChange={(selectedOption) => {
                                                        const selectedThematique = activiteEntente.activite.thematiques?.find(
                                                            (t) => t.id === selectedOption,
                                                        );
                                                        setFieldValue(
                                                            `activiteEntentes[${index}].thematique`,
                                                            selectedThematique,
                                                        );
                                                    }}
                                                />
                                                <Row>
                                                    <Col xs={LABEL_COL}>Choix pipeline</Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={LABEL_COL}>Pipeline</Col>
                                                </Row>
                                            </>
                                        )}

                                        <Row className="mt-2">
                                            <Col className="text-right">
                                                <Button
                                                    size="sm"
                                                    variant="danger"
                                                    onClick={() => supprimerActivite(index)}
                                                    disabled={values.activiteEntentes.length === 1}
                                                >
                                                    Supprimer
                                                </Button>
                                            </Col>
                                        </Row>

                                        <hr />
                                    </>
                                );
                            })}

                        <Button size="sm" variant="outline-primary" onClick={ajouterActivite}>
                            Ajouter une activité
                        </Button>
                    </MyPaper>

                    <TitreCarte>Lieu d'animation</TitreCarte>
                    <MyPaper>
                        <ChampUniqueLieu
                            id="lieu"
                            placeholder="Adresse de facturation du client (entente) ou au premier lieu de la première Sortie"
                            lieux={lieux}
                            label={"Lieu d'animation"}
                            titreBouton="Choisir le lieu d'animation"
                            selectedLieu={values.lieu}
                            disableOnce
                            hideX
                        />
                    </MyPaper>
                    <TitreCarte>Produits</TitreCarte>
                    <MyPaper>
                        {values.activiteEntentes &&
                        values.activiteEntentes.filter(function (element) {
                            return element !== null && element !== undefined;
                        }).length > 0 ? (
                            <TableActiviteEntenteProduit
                                onAdd={(data) => {
                                    const index = values.activiteEntentes.findIndex(
                                        (ae) => ae && ae.id === data.activiteEntente.id,
                                    );
                                    if (index !== -1) {
                                        const updatedActiviteEntentes = [...values.activiteEntentes];
                                        if (!updatedActiviteEntentes[index].activiteEntenteProduit) {
                                            updatedActiviteEntentes[index].activiteEntenteProduit = [];
                                        }
                                        updatedActiviteEntentes[index].activiteEntenteProduit.push(data);
                                        setFieldValue('activiteEntentes', updatedActiviteEntentes);
                                    }
                                }}
                                onModify={(activiteIndex, produitIndex, data) => {
                                    const updatedActiviteEntentes = [...values.activiteEntentes];
                                    updatedActiviteEntentes[activiteIndex].activiteEntenteProduit[produitIndex] = data;
                                    setFieldValue('activiteEntentes', updatedActiviteEntentes);
                                }}
                                onRemove={(activiteIndex, produitIndex) => {
                                    const updatedActiviteEntentes = [...values.activiteEntentes];
                                    updatedActiviteEntentes[activiteIndex].activiteEntenteProduit.splice(
                                        produitIndex,
                                        1,
                                    );
                                    setFieldValue('activiteEntentes', updatedActiviteEntentes);
                                }}
                            />
                        ) : (
                            <i>Sélectionnez d'abord une activité.</i>
                        )}
                    </MyPaper>
                    <TitreCarte>{modeleHoraireSelectionne ? 'Horaire' : "Sélection de modèle d'horaire"}</TitreCarte>
                    <MyPaper>
                        {!modeleHoraireSelectionne ? (
                            <div className="d-flex flex-column" style={{ gap: '20px' }}>
                                <div className="d-flex flex-column" style={{ gap: '10px' }}>
                                    <Col xs={LABEL_COL} className="pl-0">
                                        Horaires par défaut
                                    </Col>
                                    <Row className="ml-0 gx-1">
                                        {values.activiteEntentes.map((activiteEntente, index) => (
                                            <React.Fragment key={index}>
                                                <Col key={index} xs="auto">
                                                    {activiteEntente?.activite?.horaireParDefaut &&
                                                        activiteEntente?.activite?.horaireParDefaut.actif && (
                                                            <Button
                                                                variant="outline-primary"
                                                                size="sm"
                                                                onClick={() =>
                                                                    initHoraire(
                                                                        activiteEntente?.activite.horaireParDefaut
                                                                            .horaire,
                                                                    )
                                                                }
                                                            >
                                                                {'Activité ' + activiteEntente?.activite.name}
                                                            </Button>
                                                        )}
                                                </Col>
                                            </React.Fragment>
                                        ))}
                                        {values.activiteEntentes
                                            .map((ae) => (ae ? ae.activiteEntenteProduit : []))
                                            .flat()
                                            .map((aep) => ({ ...aep }))
                                            .filter(function (element) {
                                                return element !== null && element !== undefined;
                                            })
                                            .map((activiteEntenteProduit, index) => (
                                                <React.Fragment key={index}>
                                                    {activiteEntenteProduit?.produit?.horaireParDefaut &&
                                                        activiteEntenteProduit?.produit?.horaireParDefaut.actif && (
                                                            <Col key={index} xs="auto">
                                                                <Button
                                                                    variant="outline-primary"
                                                                    size="sm"
                                                                    onClick={() =>
                                                                        initHoraire(
                                                                            activiteEntenteProduit?.produit
                                                                                .horaireParDefaut.horaire,
                                                                        )
                                                                    }
                                                                >
                                                                    {'Produit ' + activiteEntenteProduit?.produit.name}
                                                                </Button>
                                                            </Col>
                                                        )}
                                                </React.Fragment>
                                            ))}
                                    </Row>
                                </div>
                                <div className="d-flex flex-column" style={{ gap: '10px' }}>
                                    <Col xs={LABEL_COL} className="pl-0">
                                        Autres modèles d'horaire
                                    </Col>
                                    <Row className="ml-0">
                                        {values.activiteEntentes.map((activiteEntente, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    {activiteEntente?.activite?.modelesHorairesActivite && (
                                                        <Col>
                                                            <Col className="text-nowrap overflow-hidden text-truncate">
                                                                <span>
                                                                    {'Activité ' + activiteEntente?.activite.name}
                                                                </span>{' '}
                                                                <Tooltip
                                                                    tooltip={activiteEntente?.activite.name}
                                                                    id={`activite-${activiteEntente?.activite.id}`}
                                                                    href={`../activites/${activiteEntente?.activite.id}`}
                                                                />
                                                            </Col>
                                                            <ChampFormulaire
                                                                labelCol={LABEL_COL}
                                                                suggestions={activiteEntente?.activite.modelesHorairesActivite
                                                                    ?.filter(
                                                                        ({ modeleHoraire }) => modeleHoraire?.actif,
                                                                    )
                                                                    .map((t) => ({
                                                                        value: t.id,
                                                                        label: t.modeleHoraire?.name,
                                                                    }))}
                                                                id={`activiteEntentes[${index}].activite.modelesHorairesActivite[${index}].name`}
                                                                estPetit
                                                                cacherTitre
                                                                notifyChange={(selectedOption) => {
                                                                    const selectedHoraire = activiteEntente?.activite.modelesHorairesActivite?.find(
                                                                        (t) => t.modeleHoraire.id === selectedOption,
                                                                    )?.modeleHoraire.horaire;
                                                                    if (selectedHoraire) initHoraire(selectedHoraire);
                                                                }}
                                                            />
                                                        </Col>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
                                        {values.activiteEntentes
                                            .map((ae) => (ae ? ae.activiteEntenteProduit : []))
                                            .flat()
                                            .map((aep) => ({ ...aep }))
                                            .filter(function (element) {
                                                return element !== null && element !== undefined;
                                            })
                                            .map((activiteEntenteProduit, index) => {
                                                return (
                                                    <React.Fragment key={index}>
                                                        {activiteEntenteProduit?.produit?.modelesHorairesProduit && (
                                                            <Col>
                                                                <Col className="text-nowrap overflow-hidden text-truncate">
                                                                    <span>
                                                                        {'Produit ' +
                                                                            activiteEntenteProduit?.produit.name}
                                                                    </span>{' '}
                                                                    <Tooltip
                                                                        tooltip={activiteEntenteProduit?.produit.name}
                                                                        id={`produit-${activiteEntenteProduit?.produit.id}`}
                                                                        href={`../produits/${activiteEntenteProduit?.produit.id}`}
                                                                    />
                                                                </Col>
                                                                <ChampFormulaire
                                                                    labelCol={LABEL_COL}
                                                                    suggestions={activiteEntenteProduit?.produit.modelesHorairesProduit
                                                                        ?.filter(
                                                                            ({ modeleHoraire }) => modeleHoraire?.actif,
                                                                        )
                                                                        .map((t) => ({
                                                                            value: t.id,
                                                                            label: t.modeleHoraire?.name,
                                                                        }))}
                                                                    id={`activiteEntenteProduit[${index}].produit.modelesHorairesProduit[${index}].name`}
                                                                    estPetit
                                                                    cacherTitre
                                                                    notifyChange={(selectedOption) => {
                                                                        const selectedHoraire = activiteEntenteProduit?.produit.modelesHorairesProduit?.find(
                                                                            (t) =>
                                                                                t.modeleHoraire.id === selectedOption,
                                                                        )?.modeleHoraire.horaire;
                                                                        if (selectedHoraire)
                                                                            initHoraire(selectedHoraire);
                                                                    }}
                                                                />
                                                            </Col>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                    </Row>
                                </div>
                                <div className="d-flex flex-column" style={{ gap: '10px' }}>
                                    <ChampMultipleModelesHoraire
                                        id="modele_horaire"
                                        maxSize={
                                            values.activiteEntentes.some(
                                                (activiteEntente) =>
                                                    activiteEntente?.activite?.modelesHorairesActivite !== undefined,
                                            )
                                                ? 1
                                                : 0
                                        }
                                        labelCol={LABEL_COL}
                                        onChange={(modeleHoraire) => initHoraire(modeleHoraire.horaire)}
                                    />
                                </div>
                            </div>
                        ) : (
                            <>
                                {values.horaire && (
                                    <TableHoraireEntente
                                        clientActiviteFournisseurMapHoraire={clientActiviteFournisseurMapHoraire}
                                    />
                                )}
                                <Row className="mt-2">
                                    <Col className="text-right">
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            onClick={() => setModeleHoraireSelectionne(false)}
                                        >
                                            Retour vers la sélection d'horaire
                                        </Button>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </MyPaper>

                    <TitreCarte>Notes</TitreCarte>
                    <MyPaper>
                        <NotesEntente />
                    </MyPaper>
                    <TitreCarte>Historique des courriels</TitreCarte>
                    <MyPaper>
                        <HistoriqueCourrielsEntente idEntente={values.id} />
                    </MyPaper>
                </>
            )}
            {afficherModalClientContact ? (
                <ModalClientContact
                    afficher={afficherModalClientContact}
                    setAfficher={() => setAfficherModalClientContact(false)}
                    index={indexModalClientContact}
                />
            ) : null}
            {/*

                table produits headers
                fournisseur - act - prod - qte client dernière valeur OU décider de quelle valeur afficher manuellement - qte fournisseur - prix client - total (qte * prix client) - prix fournisseur - total (qte * prix fournisseur) - profit
                dernière ligne en bas est un total des prix
                popup qte voir historique & détails

                Si on est le 1er juin, que le prix change le 1er juillet et qu'on est en train de créer une entente qui commence le 1er septembre,
                quel prix devrait être choisi par défaut? Le prix de la date de l'activité.

                produits

                Notes de l'entente (voir document word conception UI)

                horaire

                statut // avoir la possibilité de modifier le statut de l'entente manuellement, avec détection automatique du statut. Voir le statut en haut, [statut] [bouton modifier]
                Ne pas enregistrer étendue d'âge si la case modifier la fiche du client est cochée

                discussion créer entente puis modifier : ça ne dérangerais pas isaac d'avoir juste le client comme champ au départ. Faire ce qui est le plus simple.


Si on veut pouvoir faire de la validation de donnée, il faut pouvoir avoir des formats standards. On peut gérer ultérieurement une affiche pus beau pour le client (ex: ne pas lister 6X année, et transformer de maternelle à 6e année).
Les checkbox, comme dans le Héraut sont (je pense) la meilleure manière de faire.
Notre use case régulier c'est:
Maternelle
1re année
2e année
3e année
4e année
5e année
6e année

Mais il faudrait aussi pouvoir avoir d'autres choix/listes (ado, adultes, tous âges, etc).
Endroits que ça doit affecter:
Dans la fiche client : je laisse le select et j'ajoute les checkboxes pour que tu puisse les remettre manuellement
Sinon je pourrais aussi faire un script qui coche automatiquement les groupes d'âge
Peux-tu faire un script qui coche automatiquement les groupes d'âge ET me laisser le select.
Après je vérifie partout. Ça me permettra da visualiser la valeur antérieure et le sript aura X% de chances de m'avoir sauvé du temps.
On pourra enlever le select ensuite OU le laisser pour l'affichage (à discuter) 
Dans la page de création d'entente : j'afficherais juste les checkboxes -> Oui
Avez des avis quand ça ne concorde pas et une option d'overide. 
Dans la page d'activité: Champ public cible
C'est ici qu'on va mettre l'autre valeur à valider.

Ex: À la création d'une entente, le client a un groupe d'âge par défaut de maternelle à 6e, 
mais l'activité choisir elle a 3e à 6e année.
Donc, il y a un avis.
Mais je peux modifier le groupe d'âge dans l'entente de 3e à 6e. 



                */}
        </div>
    );
}

export default function DetailsEntente(): ReactElement {
    const { id } = useParams() as { id: string };
    const listLogs = useGetQuery<HistoriqueLogs[]>(`historique_logs/${id}/ententes`);

    function nettoyer(c: Entente): void {
        if (c.activiteEntentes[0] !== null) c.activiteEntentes?.forEach((ae) => delete ae.activite['label']);
        c.activiteEntentes.forEach((ae, i) => {
            if (ae) {
                ae.fk_id_entente = c.id;
                ae.priorite = i;
            }
        });
        c.contacts.forEach((contact) => {
            if (contact) contact.fk_id_entente = c.id;
        });
        c['est_sortie'] = c.activiteEntentes.some(
            (ae) => ((ae?.activite?.typeActivite as unknown) as string) === 'Sortie',
        );

        if (!c['copie_locale_client']) {
            delete (c as Partial<typeof c>).contacts;
            delete (c as Partial<typeof c>).roles;
        }

        c.notes.forEach((note) => {
            note.fk_id_entente = c.id;
        });

        delete c.client['label'];

        c.activiteEntentes?.forEach((ae) => {
            ae?.activiteEntenteProduit?.forEach((aep) => {
                aep.fk_id_produit = aep.produit.id;
                aep.fk_id_facturation = aep.facturation?.id;
                aep.fk_id_activite_entente = ae.id;
                delete (aep as Partial<typeof aep>).activiteEntente;
                aep.nombreLogs?.forEach((nl) => {
                    nl.fk_id_activite_entente_produit = aep.id;
                    delete (nl as Partial<typeof nl>).activiteEntenteProduit;
                    nl.pions?.forEach((p) => {
                        p.fk_nombre_log = nl.id;
                        delete (p as Partial<typeof p>).nombreLog;
                    });
                });
            });
        });
    }

    return (
        <div>
            <FormulaireModificationEntite
                id={+id}
                entite={Entente}
                nettoyer={nettoyer}
                badges={(c: Entente) => [
                    `Entente #${c.id}`,
                    `Dernière modification: ${
                        listLogs.data?.[listLogs.data.length - 1]?.date_modification
                            ? dateFormatter(listLogs.data?.[listLogs.data.length - 1]?.date_modification)
                            : 'Aucune modificiation'
                    } par ${listLogs.data?.[listLogs.data.length - 1]?.nom_usager ?? ''}`,
                ]}
            >
                <ChampsEntente />
            </FormulaireModificationEntite>
            <LogsLoader id={id} tableName={'ententes'} />
        </div>
    );
}
